export const routes_empresas_revision=[
    {
        path: 'empresas/listado',
        name: 'listado',
        component: () => import('../Listas/listado_empresas')
    },
    {
        path: 'empresas/revision/:id',
        name: 'revision',
        component: () => import('./index_revisar_informacion')
    },
    {
        path: 'empresas/revision_validacion/:id',
        name: 'revision_validacion',
        component: () => import('./index_agregar_observaciones')
    },
    {
        path: 'empresas/revision_informacion/:id',
        name: 'revision_informacion',
        component: () => import('./index_modificar_informacion')
    },
    {
        path: '/empresas/completar_datos/:id',
        name: 'text',
        component: () => import( '../documentos_proveedor')
    }
]